export default __webpack_public_path__ + "static/media/gm.f52cde2e.svg";